module.exports = __webpack_public_path__ + "static/media/checklist.9afe277a.svg";